import { ExtendableError } from './extendable_error.error'

export class NotFoundError extends ExtendableError {
  constructor (meta = {}) {
    super('Not found')
    this.errorType = 'Not found'
    this.meta = meta
  }
}



// WEBPACK FOOTER //
// ./src/js/errors/not_found.error.js